//#region src/constant.ts
const DEFAULT_SCOPE = "default";
const DEFAULT_REMOTE_TYPE = "global";

//#endregion
export { DEFAULT_REMOTE_TYPE, DEFAULT_SCOPE };
//# sourceMappingURL=constant.js.map